/* eslint-disable @typescript-eslint/no-explicit-any */
import { TripBookColor } from '51trips-frontend-core'

const tripBookColorConverter = {
  fromFirestore: (data: any) => {
    if (data) {
      let id: string
      if (typeof data.id === 'string') {
        id = data.id
      } else {
        return undefined
      }

      let hexColor: string
      if (typeof data.hex === 'string') {
        hexColor = data.hex
      } else {
        return undefined
      }

      let isActive: boolean = false
      if (typeof data.isActive === 'boolean') {
        isActive = data.isActive
      }

      return new TripBookColor(id, hexColor, isActive)
    } else {
      return undefined
    }
  }
}

export default tripBookColorConverter
